import axios from '@/util/request';

export function getDepotInfo(parameter) {
  //获取仓库
  return axios({
    url: '/ims/depot/getDepotInfo',
    method: 'get',
    params: parameter,
  })
}

export function getCabinetInfo(parameter) {
  //获取仓库仪器
  return axios({
    url: '/ims/Cabinet/GetCabinetInfo',
    method: 'get',
    params: parameter,
  })
}


export function BindingInfo(data) {
  //绑定仪器组仪器
  return axios({
    url: '/ims/instrument/Binding',
    method: 'post',
    data: data,
  })
}
export function UntieCombind(data) {
  //解绑仪器组仪器
  return axios({
    url: '/ims/instrument/UntieCombind',
    method: 'post',
    data: data,
  })
}

export function getInstrumentPageList(parameter) {
  //获取仪器列表
  return axios({
    url: '/ims/instrument/page',
    method: 'post',
    data: parameter
  })
}

export function getInstrumentList(parameter) {
  //获取仪器列表
  return axios({
    url: '/ims/instrument/page/maintained',
    method: 'post',
    data: parameter
  })
}
export function getRecordByInsId(parameter) {
  //根据仪器获取出入库记录
  return axios({
    url: '/ims/useInfo/getRecordByInsId',
    method: 'get',
    params: parameter
  })
}

export function getInstrument(id) {
  //获取单个仪器数据
  return axios({
    url: '/ims/instrument/' + id,
    method: 'get',
  })
}
export function getRecordTemplateType() {
  //获取单个仪器数据
  return axios({
    url: '/ims/useInfo/getRecordTemplateType',
    method: 'get',
  })
}


export function getBrokeInsList(parameter) {
  //获取异常仪器列表
  return axios({
    url: '/ims/instrument/page/broke',
    method: 'post',
    data: parameter
  })
}

export function delectInstrument(parameter) {
  //删除仪器
  return axios({
    url: '/ims/instrument/delete/' + parameter.id,
    method: 'get',
    // params: parameter,
  })
}
export function removeApply2(applyId) {
  //删除仪器
  return axios({
    url: '/ims/UseApply/removeApply2/' + applyId,
    method: 'DELETE',
    // params: parameter,
  })
}
export function deleteFile(parameter) {
  //删除附件
  return axios({
    url: '/ims/uploadfile/deleteFile',
    method: 'DELETE',
    params: parameter,
  })
}
export function createInstrument(data) {
  //新增仪器
  return axios({
    url: '/ims/instrument',
    // headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    data: data
  })
}
//修改仪器电量状态
export function ChangePowerStates(parameter) {
  //新增仪器柜
  return axios({
    url: '/ims/instrument/changePowerStates',
    method: 'put',
    params: parameter,
  })
}

//获取文件在线地址
export function FileUrl(parameter) {
  //获取文件地址（objectName）
  return axios({
    url: '/admin/sys-file/getObjectURL',
    method: 'get',
    params: parameter
  })
}

export function uploadingFile(data) {
  //文件下载
  return axios({
    url: '/ims/File/Upload',
    method: 'post',
    data,
  })
}

//使用管理界面接口

export function getMainta(data) {
  //处理保养数据
  return axios({
    url: '/ims/instrument/maintain',
    method: 'post',
    data,
  })
}
export function addMainta(data) {
  //新增保养记录
  return axios({
    url: '/ims/maintainhandle',
    method: 'post',
    data,
  })
}

export function createVertifyhandle(data) {
  // 新增检定记录
  return axios({
    url: '/ims/vertifyhandle',
    method: 'post',
    data,
  })
}

export function getVerify(data) {
  //处理检定数据
  return axios({
    url: '/ims/instrument/verify',
    method: 'post',
    data,
  })
}
export function getAbnormal(data) {
  //处理检定数据
  return axios({
    url: '/ims/instrument/abnormal',
    method: 'post',
    data,
  })
}
export function MsgHandle(params) {
  //处理异常数据
  return axios({
    url: '/ims/Exception/MsgHandle',
    method: 'put',
    params,
  })
}

export function getAsysnc(parameter) {
  //获取异常信息
  return axios({
    url: '/ims/Exception/QueryInfoAsysnc',
    method: 'get',
    params: parameter,
  })
}

export function exportByIns(parameter) {
  //导出仪器使用记录
  return axios({
    url: "/ims/UseManage/ExportByIns",
    method: 'get',
    params: parameter
  })
}
export function changeStates(data) {
  //修改仪器状态
  return axios({
    url: "/ims/instrument/changeStates",
    method: 'put',
    data
  })
}

export function getByType(parameter) {
  //获取文件类型
  return axios({
    url: "/admin/dict/type/" + parameter,
    method: 'get'
  })
}
export function fileUpload(data) {
  //上传文件
  return axios({
    url: '/ims/File/Upload',
    method: 'post',
    data,
  })
}

export function delFile(parameter) {
  //删除文件，防止文件还保留
  return axios({
    url: '/ims/File/DeleteFile',
    method: 'DELETE',
    params: parameter,
  })
}

export function getRecordByIns(parameter) {
  //获取仪器使用记录
  return axios({
    url: `/ims/instrument/getRecordByIns`,
    method: 'get',
    params: parameter
  })
}

export function changeStatus(parameter) {
  //修改仪器在库状态
  return axios({
    url: "/ims/instrument/changeStatus",
    method: 'put',
    params: parameter
  })
}

export function enableDept(parameter) {
  //修改仪器在库状态2
  return axios({
    url: "/ims/dept/enableDept",
    method: 'put',
    params: parameter
  })
}

export function getIndexData() {
  //获取header统计数据
  return axios({
    url: `/ims/instrument/GetIndexData`,
    method: 'get',
  })
}

export function getRecordByUse(parameter) {
  //获取仪器出入库记录
  return axios({
    url: "/ims/useInfo/getRecordByApply",
    method: 'get',
    params: parameter
  })
}

export function getThermometerDataList(parameter) {
  //获取温湿度传感器数据列表
  return axios({
    url: "/ims/Thermometer/GetThermometerDataList",
    method: 'get',
    params: parameter
  })
}

export function getMaintainList(parameter) {
  //获取保养记录
  return axios({
    url: "/ims/maintainhandle/get",
    method: 'get',
    params: parameter
  })
}

export function deleteByItem(id) {
  //删除保养记录
  return axios({
    url: "/ims/maintainhandle/delete/" + id,
    method: 'DELETE'
  })
}

export function updateMaintainhandle(data) {
  //修改保养记录
  return axios({
    url: "/ims/maintainhandle",
    method: 'put',
    data
  })
}

export function getVertifyList(parameter) {
  //获取检定记录
  return axios({
    url: "/ims/vertifyhandle/get",
    method: 'get',
    params:parameter
  })
}

export function deleteJdItem(id) {
  //删除检定记录
  return axios({
    url: "/ims/vertifyhandle/" + id,
    method: 'DELETE'
  })
}

export function updateJdItem(data) {
  //编辑检定数据
  return axios({
    url: '/ims/vertifyhandle',
    method: 'put',
    data,
  })
}

export function exportJdItem(id) {
  //导出检定记录
  return axios({
    url: "/ims/vertifyhandle/exportDocx/" + id,
    method: 'get',
    responseType: 'blob',
  })
}

export function exportMaintain(InstrumentId) {
  //导出仪器保养记录
  return axios({
    url: "/ims/maintainhandle/exportDocx/" + InstrumentId,
    responseType: 'blob',
    method: 'get'
  })
}

///ims/project/listHistoryProject/{projectId}

export function batchExportByIns(parameter) {
  //批量导出仪器使用记录
  return axios({
    url: '/ims/instrument/exportWord',
    method: 'post',
    responseType: 'blob',
    data: parameter,
    timeout: 60 * 60 * 1000
  })
}

export function exportByInsv2(parameter) {
  //导出仪器信息
  return axios({
    url: '/ims/useInfo/exportByIns',
    method: 'post',
    responseType: 'blob',
    data: parameter,
    timeout: 60 * 60 * 1000
  })
}

export function exportExcelv2(parameter) {
  //导出仪器信息
  return axios({
    url: '/ims/instrument/exportExcel',
    method: 'post',
    responseType: 'blob',
    data: parameter,
    timeout: 60 * 60 * 1000
  })
}


// 获取带检定列表
export function GetVertifyInsList(parameter) {
  //获取仪器列表
  return axios({
    url: '/ims/instrument/page/getCheckIns',
    method: 'post',
    data: parameter
  })
}

// 获取可选的待送检仪器
export function GetVertifyInstrument(depotId) {
  //获取仪器列表
  return axios({
    url: '/ims/instrument/getVertifyInstrument/' + depotId,
    method: 'get',
  })
}

export function getRecordByProject(parameter) {
  //获取项目出入库记录
  return axios({
    url: "/ims/project/getRecordByProject",
    method: 'get',
    params: parameter
  })
}

export function NewGetRecordByProject(InstrumentId) {
  //导出仪器保养记录
  return axios({
    url: "/ims/project/listHistoryProject/" + InstrumentId,
    method: 'get'
  })
}

///ims/project/listHistoryProject/{projectId}

export function getInsAbnormalInfo(instrumentId) {
  //获取仪器异常记录
  return axios({
    url: "/ims/useInfo/getInsAbnormalInfo",
    method: 'get',
    params: { "instrumentId": instrumentId }
  })
}

export function getFreeInsList1(parameter) {
  //获取可绑定的子仪器
  return axios({
    url: '/ims/instrument/getFreeInsList1',
    method: 'post',
    data: parameter
  })
}

export function getFreeInsList2(parameter) {
  //获取可绑定格口的普通仪器
  return axios({
    url: '/ims/instrument/getFreeInsList2',
    method: 'post',
    data: parameter
  })
}

export function getFreeInsList3(parameter) {
  //获取可绑定格口的组合仪器
  return axios({
    url: '/ims/instrument/getFreeInsList3',
    method: 'post',
    data: parameter
  })
}

export function getFreeInsList4(parameter) {
  //获取可绑定的固定式仪器
  return axios({
    url: '/ims/instrument/getFreeInsList4',
    method: 'post',
    data: parameter
  })
}
export function deleteUseInfoId(id) {
  //删除设备使用记录
  return axios({
    url: "/ims/useInfo/" + id,
    method: 'DELETE'
  })
}
export function getFixedUseInfoList(parameter) {

  return axios({
    url: "/ims/useInfo/getFixedUseInfoList",
    method: 'get',
    params: parameter
  })
}
export function getFixedUseInfoListv2(parameter) {
  return axios({
    url: "/ims/applyInstrument/getUseInfo",
    method: 'get',
    params: parameter
  })
}

export function exportFixedByApply(parameter) {
  //申请管理-导出出入库记录
  return axios({
    url: '/ims/useInfo/exportFixedByApply',
    method: 'post',
    responseType: 'blob',
    data: parameter,
    timeout: 60 * 60 * 1000,
  })
}
// 获取经纬度
export function locationIp(parameter) {
  return axios({
    url: "/ws/location/v1/ip",
    method: 'get',
    params: parameter
  })
}
// 获取经纬度
export function suggestion(parameter) {
  return axios({
    url: "/ws/place/v1/suggestion",
    method: 'get',
    params: parameter
  })
}
export function exportLabel(params) {
  return axios({
    url: '/ims/instrument/exportLabel',
    method: 'post',
    responseType: 'blob',
    data: params,
  })
}


// WEBPACK FOOTER //
// ./src/api/depotApi.js